/**
 * Given validator of type `Validator<Value, Props>` and a defaultValue of type `Value`, returns a new
 * validator of type `Validator<Value | null | undefined, Props>`
 *
 * In the case where `null | undefined` is being validated, the `defaultValue`
 * is passed to the original `Validator`
 */
export function withDefaultValue(validator, defaultValue) {
    return function (value, props) { return validator(value !== null && value !== void 0 ? value : defaultValue, props); };
}
//# sourceMappingURL=withDefaultValue.js.map